import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AdminSearchComponent } from '../../../components/admin/admin.search';
import { AdminInquiryTableComp } from './admin.inquiry.table';
import { fetchAdminInquiryList } from '../../../api/admin.inquiry';

interface FetchAdminInquiryParams {
  title?: string;
}

interface InquiryDtoRx {
  inquiryId: number;
  title: string;
  createdAt: string;
  passid: string;
  state: string;
}

const AdminInquiryList = () => {
  const [inquiryList, setInquiryList] = useState<InquiryDtoRx[] | null>(null);
  const [searchParams, setSearchParams] = useState<FetchAdminInquiryParams>({});

  console.log(searchParams);

  useEffect(() => {
    const getInquiryList = async () => {
      try {
        const response = await fetchAdminInquiryList(searchParams);
        setInquiryList(response);
      } catch (error) {
        console.error(error);
      }
    };

    getInquiryList();
  }, [searchParams]);

  // 검색 필터 값 변경을 처리하는 함수
  const handleSearchChange = (params: FetchAdminInquiryParams) => {
    setSearchParams(params); // 필터 값을 업데이트하여 API 호출을 트리거함
  };

  return (
    <Container>
      <AdminSearchComponent
        handleSearchChange={handleSearchChange}
        searchType="onlyTitle"
      />

      {inquiryList ? (
        <AdminInquiryTableComp
          data={inquiryList || []}
          setInquiryList={setInquiryList}
        />
      ) : null}
    </Container>
  );
};

export default AdminInquiryList;

// style
const Container = styled.div``;
